import { z } from "zod";
const driedFlowerProductTypeSchema = z.enum(["single-variety", "mixed-bunch", "confetti"]);
export const driedFlowerProductTypes = driedFlowerProductTypeSchema.options;
const driedFlowerProductTypeLabels = {
    "single-variety": "Single Variety",
    "mixed-bunch": "Mixed Bunch",
    confetti: "Flower Confetti",
};
export function getDriedFlowerProductTypeLabel(type) {
    var _a;
    return (_a = driedFlowerProductTypeLabels[type]) !== null && _a !== void 0 ? _a : type;
}
export function driedFlowerUsesBunchUnit(type) {
    return type === "single-variety" || type === "mixed-bunch";
}
//# sourceMappingURL=dried-flowers.js.map